import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile_member_center"
}
const _hoisted_2 = { class: "user_info_box flex_space_center" }
const _hoisted_3 = { class: "flex_start_center" }
const _hoisted_4 = { class: "user_head" }
const _hoisted_5 = { class: "user_desc flex_column_starts" }
const _hoisted_6 = {
  key: 0,
  class: "pay_setting_container"
}
const _hoisted_7 = { class: "pay_outer_container" }
const _hoisted_8 = { class: "pay_setting_box" }
const _hoisted_9 = { class: "pay_ul mgl_18" }
const _hoisted_10 = {
  key: 0,
  class: "top_tip"
}
const _hoisted_11 = { class: "pay_box" }
const _hoisted_12 = { class: "pay_top" }
const _hoisted_13 = { class: "pay_price" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" ¥ ")
const _hoisted_15 = { class: "pay_desc" }
const _hoisted_16 = { class: "discount_price_text" }
const _hoisted_17 = { class: "renew_container" }
const _hoisted_18 = { class: "pay_renew flex_start_center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "到期自动续费", -1)
const _hoisted_20 = { class: "pay_renew mgl_34" }
const _hoisted_21 = {
  key: 0,
  class: "coupon_and_pay_item clear"
}
const _hoisted_22 = { class: "common_item flex_space_center" }
const _hoisted_23 = { class: "flex_start_center" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "coupon_icon" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "使用优惠券立减", -1)
const _hoisted_26 = { class: "red_price_text" }
const _hoisted_27 = { class: "flex_start_center" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "common_item flex_space_center" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex_start_center" }, [
    /*#__PURE__*/_createVNode("i", { class: "wechat_icon" }),
    /*#__PURE__*/_createVNode("span", null, "微信支付")
  ]),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("i", { class: "checkbox_active" })
  ])
], -1)
const _hoisted_29 = { class: "interest_box" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "interest_title" }, "会员享有特权", -1)
const _hoisted_31 = { class: "interest_ul flex_start_center" }
const _hoisted_32 = {
  key: 1,
  class: "label_title"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 更多功能")
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("敬请期待 ")
const _hoisted_36 = {
  key: 1,
  class: "start_pay"
}
const _hoisted_37 = { class: "pay_desc_action flex_start_center" }
const _hoisted_38 = { class: "pay_desc_left" }
const _hoisted_39 = { class: "flex_start_center" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 实付： ")
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "font_20" }, "¥ ", -1)
const _hoisted_42 = { class: "font_26" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 已阅读并同意 ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 及 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AcceptProtocol = _resolveComponent("AcceptProtocol")!

  return (_ctx.viewModel.render)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("img", {
                src: _ctx.viewModel.avatar,
                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.errorUseDefaultImage && _ctx.errorUseDefaultImage(...args)))
              }, null, 40, ["src"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("span", null, _toDisplayString(_ctx.viewModel.nickname), 1),
              _createVNode("span", null, _toDisplayString(_ctx.headText), 1)
            ])
          ]),
          (_ctx.noContinuousMember)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "user_renew_btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.MemberRenewAction && _ctx.MemberRenewAction(...args)))
              }, "续费"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.viewModel.payModuleShow)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("ul", _hoisted_9, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settings, (p, pIdx) => {
                          return (_openBlock(), _createBlock("li", {
                            key: pIdx,
                            class: { pay_active: pIdx === _ctx.viewModel.payIdx },
                            onClick: ($event: any) => (_ctx.switchPaySetting(pIdx))
                          }, [
                            (p.page_detail.title)
                              ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(p.page_detail.title), 1))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_11, [
                              _createVNode("div", _hoisted_12, [
                                _createVNode("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createVNode("span", null, _toDisplayString(p.page_detail.current_fee), 1)
                                ]),
                                _createVNode("div", _hoisted_15, _toDisplayString(p.page_detail.discount_desc), 1)
                              ]),
                              _createVNode("div", _hoisted_16, _toDisplayString(p.page_detail.bottom), 1)
                            ])
                          ], 10, ["onClick"]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _withDirectives(_createVNode("div", _hoisted_18, [
                      _createVNode("div", {
                        class: "renew_box flex_start_center",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleRenewStatus && _ctx.toggleRenewStatus(...args)))
                      }, [
                        _createVNode("span", {
                          class: ['renew_btn', { checkout_active: _ctx.viewModel.renewChecked }]
                        }, null, 2),
                        _hoisted_19
                      ]),
                      _createVNode("span", {
                        class: "renew_text",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openProtocol && _ctx.openProtocol(...args)))
                      }, "《自动续费服务协议》")
                    ], 512), [
                      [_vShow, _ctx.controlRenewShow]
                    ]),
                    _withDirectives(_createVNode("div", _hoisted_20, "钻石会员，不限时享受高级特权！", 512), [
                      [_vShow, _ctx.controlDiamondTextShow]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.viewModel.payModuleShow)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _hoisted_25,
                      _createVNode("span", _hoisted_26, _toDisplayString(_ctx.couponPrice) + "元", 1)
                    ]),
                    _createVNode("div", _hoisted_27, [
                      _createVNode("i", {
                        class: { checkbox_active: _ctx.viewModel.useCouponStatus },
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.useCouponAction && _ctx.useCouponAction(...args)))
                      }, null, 2)
                    ])
                  ], 512), [
                    [_vShow, _ctx.couponPrice]
                  ])
                ]),
                _: 1
              }),
              _hoisted_28
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode("ul", _hoisted_31, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.interestList, (item, idx) => {
              return (_openBlock(), _createBlock("li", {
                key: idx,
                class: "flex_column_centers"
              }, [
                _createVNode("div", {
                  class: ['img_box', { hot_icon: item.hot, new_icon: item.new }]
                }, [
                  _createVNode("img", {
                    src: item.img
                  }, null, 8, ["src"])
                ], 2),
                (item.type !== 'line_feed')
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "label_title",
                      textContent: _toDisplayString(item.label)
                    }, null, 8, ["textContent"]))
                  : (_openBlock(), _createBlock("span", _hoisted_32, [
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35
                    ]))
              ]))
            }), 128))
          ])
        ]),
        (_ctx.viewModel.payModuleShow)
          ? (_openBlock(), _createBlock("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _hoisted_41,
                    _createVNode("span", _hoisted_42, _toDisplayString(_ctx.currentPrice), 1)
                  ]),
                  _createVNode("div", {
                    class: "agreement_box flex_start_center",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleAgreeProtocol && _ctx.toggleAgreeProtocol(...args)))
                  }, [
                    _createVNode("i", {
                      class: ['agree_checkbox', { agree_active: _ctx.viewModel.agreeProtocol }]
                    }, null, 2),
                    _createVNode("span", null, [
                      _hoisted_43,
                      _createVNode("span", {
                        class: "common_bottom_subtitle_link",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openUserProtocol && _ctx.openUserProtocol(...args)), ["stop"]))
                      }, "用户协议"),
                      _hoisted_44,
                      _createVNode("span", {
                        class: "common_bottom_subtitle_link",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openPrivacyProtocol && _ctx.openPrivacyProtocol(...args)), ["stop"]))
                      }, "隐私政策")
                    ])
                  ])
                ]),
                _createVNode("div", {
                  class: "pay_action",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.payAction && _ctx.payAction(...args)))
                }, "立即支付")
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_AcceptProtocol, {
          visible: _ctx.viewModel.showAcceptProtocol,
          "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.viewModel.showAcceptProtocol = $event)),
          onConfirm: _ctx.confirmAcceptProtocol,
          onOpenUserProtocol: _ctx.openUserProtocol,
          onOpenPrivacyProtocol: _ctx.openPrivacyProtocol
        }, null, 8, ["visible", "onConfirm", "onOpenUserProtocol", "onOpenPrivacyProtocol"])
      ]))
    : _createCommentVNode("", true)
}